/* Nutri-Plus-Rabatt-Popup: fängt Klicks auf alle mdsh.io / nutri-plus.de-Links ab,
   zeigt den aktuell gültigen Code (Datumsfenster wird client-seitig exakt geprüft)
   und führt dann zum sprachrichtigen Tracking-Link weiter. */
(function () {
  var overlay = document.getElementById('nutriplus-popup');
  if (!overlay) return;

  function activeCodeAndDiscount() {
    var now = Date.now() / 1000;
    var start = parseInt(overlay.dataset.promoStart || '', 10);
    var end = parseInt(overlay.dataset.promoEnd || '', 10);
    var promoCode = overlay.dataset.promoCode;
    if (promoCode && !isNaN(start) && !isNaN(end) && now >= start && now <= end + 86399) {
      return { code: promoCode, discount: overlay.dataset.promoDiscount || overlay.dataset.defaultDiscount, promo: true };
    }
    return { code: overlay.dataset.defaultCode, discount: overlay.dataset.defaultDiscount, promo: false };
  }

  function openPopup(targetUrl) {
    var state = activeCodeAndDiscount();
    var codeEl = overlay.querySelector('[data-np-code]');
    var titleEl = overlay.querySelector('.nutriplus-popup__title');
    var promoTextEl = overlay.querySelector('.nutriplus-popup__promo-text');
    if (codeEl) codeEl.textContent = state.code;
    if (titleEl) titleEl.textContent = titleEl.textContent.replace(/-?\d+\s?%/, '-' + state.discount.replace(/^-/, ''));
    if (promoTextEl) promoTextEl.hidden = !state.promo;
    var continueBtn = overlay.querySelector('[data-np-continue]');
    if (continueBtn) continueBtn.href = targetUrl || overlay.dataset.link;
    overlay.hidden = false;
    document.body.classList.add('no-pinch');
    var closeEl = overlay.querySelector('.nutriplus-popup__close');
    if (closeEl) { window.__npPrevFocus = document.activeElement; closeEl.focus(); }
  }

  // Ausser Deutsch fuehren alle Sprachen auf den englischen Shop. Deutsche
  // Produktpfade werden ueber die Tabelle aus snippets/nutriplus-en-pfade
  // umgeschrieben; unbekannte Pfade landen auf der englischen Startseite.
  function englischerPfad(href) {
    var tabelle = overlay.dataset.enPfade;
    if (!tabelle) return href;
    try {
      var u = new URL(href);
      if (/^\/en(\/|$)/.test(u.pathname)) return href;
      var paare = tabelle.split('|');
      for (var i = 0; i < paare.length; i++) {
        var teile = paare[i].split('>');
        if (u.pathname.indexOf(teile[0]) === 0) {
          return 'https://www.nutri-plus.de' + teile[1] + u.pathname.slice(teile[0].length) + u.search;
        }
      }
    } catch (err) {}
    return overlay.dataset.link || href;
  }

  function closePopup() {
    overlay.hidden = true;
    if (window.__npPrevFocus && window.__npPrevFocus.focus) { window.__npPrevFocus.focus(); window.__npPrevFocus = null; }
    document.body.classList.remove('no-pinch');
    var copyBtn = overlay.querySelector('[data-np-copy]');
    if (copyBtn) copyBtn.textContent = copyBtn.dataset.originalLabel || copyBtn.textContent;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="mdsh.io"], a[href*="nutri-plus.de"]');
    if (!link || link.hasAttribute('data-np-continue')) return;
    e.preventDefault();
    e.stopPropagation();
    // Produkt-Deeplinks (nutri-plus.de/<produkt>) bleiben erhalten — nur reine
    // Tracking-Kurzlinks (mdsh.io) werden durch den zentralen, sprachrichtigen Link ersetzt.
    var href = link.href || '';
    var isProductDeepLink = false;
    try {
      var u = new URL(href);
      isProductDeepLink = /nutri-plus\.de$/i.test(u.hostname.replace(/^www\./, '')) && u.pathname.length > 1;
    } catch (err) {}
    if (window.nvsinoTrack) {
      window.nvsinoTrack('nutriplus_klick', {
        art: isProductDeepLink ? 'produktlink' : 'trackinglink',
        code: activeCodeAndDiscount().code,
        aktion_laeuft: activeCodeAndDiscount().promo
      });
    }
    openPopup(isProductDeepLink ? englischerPfad(href) : (overlay.dataset.link || href));
  }, true);

  overlay.addEventListener('click', function (e) {
    e.stopPropagation(); // nicht zum PDF-Viewer durchreichen (der schließt bei Außenklicks)
    if (e.target === overlay || e.target.closest('.nutriplus-popup__close')) closePopup();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closePopup();
  });

  var copyBtn = overlay.querySelector('[data-np-copy]');
  if (copyBtn) {
    copyBtn.dataset.originalLabel = copyBtn.textContent.trim();
    copyBtn.addEventListener('click', function () {
      var code = overlay.querySelector('[data-np-code]').textContent.trim();
      if (window.nvsinoTrack) window.nvsinoTrack('nutriplus_code_kopiert', { code: code });
      var done = function () { copyBtn.textContent = '✓'; setTimeout(function () { copyBtn.textContent = copyBtn.dataset.originalLabel; }, 1500); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (err) {}
        ta.remove();
      }
    });
  }

  // Weiter-Button schließt das Popup (Link öffnet in neuem Tab)
  var continueBtn = overlay.querySelector('[data-np-continue]');
  if (continueBtn) continueBtn.addEventListener('click', function () {
    if (window.nvsinoTrack) {
      window.nvsinoTrack('nutriplus_weiter', {
        code: activeCodeAndDiscount().code,
        ziel: (continueBtn.href || '').slice(0, 120)
      });
    }
    setTimeout(closePopup, 150);
  });
})();
